__turbopack_context__.v({
  "fadeInUp": "contactHeroSection-module__NxtrBa__fadeInUp",
  "heroDescription": "contactHeroSection-module__NxtrBa__heroDescription",
  "heroTitle": "contactHeroSection-module__NxtrBa__heroTitle",
  "heroTitleGradient": "contactHeroSection-module__NxtrBa__heroTitleGradient",
});
